import { useMemo } from "react";
import { useGetReportTypesQuery } from "shared/api";

export const useReportTypes = () => {
  const { data: reportTypes, isLoading, error } = useGetReportTypesQuery();

  const reportTypeOptions = useMemo(() => {
    if (!reportTypes?.result || !Array.isArray(reportTypes.result)) {
      return [];
    }

    return reportTypes.result.map((type) => ({
      label: type,
      value: type,
    }));
  }, [reportTypes]);

  return {
    reportTypes: reportTypes?.result || [],
    reportTypeOptions,
    isLoading,
    error,
  };
};
